module.exports = __webpack_public_path__ + "media/images/shark/Chippy-p-500-e151261fd00bc820569ad4a4dd87a917.jpeg";